import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '@bingads-webui-react/primitive';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getDefaultModalStyle } from '../styles/common-styles';

export const ConfirmDialog = ({
  name,
  onConfirm,
  onDecline,
  title,
  content,
  confirmButtonText,
  declineButtonText,
  isShow,
  dialogClassName,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getDefaultModalStyle);

  return (
    <Modal show={isShow} backdrop="static" dialogClassName={dialogClassName || classes.modalWidth} className={`${name}-confirm-dialog`} onHide={onDecline}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`${name}-confirm-dialog-content`}>
        <div>
          {content}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="confirm-button" btnStyle="primary" onClick={onConfirm}>{confirmButtonText || i18n.getString(_TL_('Yes'))}</Button>
        <Button className="decline-button" onClick={onDecline}>{declineButtonText || i18n.getString(_TL_('No'))}</Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmDialog.propTypes = {
  name: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  confirmButtonText: PropTypes.string,
  declineButtonText: PropTypes.string,
  isShow: PropTypes.bool,
  dialogClassName: PropTypes.string,
};

ConfirmDialog.defaultProps = {
  confirmButtonText: null,
  declineButtonText: null,
  isShow: true,
  dialogClassName: null,
};
